import { createApi } from '@reduxjs/toolkit/query/react';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { ConnectionFTPInterface } from '@interface/connection/connection.interface';
import { ConnectorInterface } from '@interface/connector/connector.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { portalQueryAuth } from '@util/api/portal-query-auth';

export const connectorApi = createApi({
  reducerPath: 'connector-api',
  tagTypes: [TagTypesEnum.Connector, TagTypesEnum.ConnectorFTP],
  baseQuery: portalQueryAuth('/connectors'),
  endpoints: (build) => ({
    loadConnectors: build.query<ResponseDataInterface<ConnectorInterface[]>, undefined>({
      query: () => '/',
      providesTags: [TagTypesEnum.Connector],
    }),
    loadFTPConfig: build.query<
      ResponseDataInterface<ConnectionFTPInterface>,
      { serviceId: string; application: string }
    >({
      query: ({ serviceId, application }) => `/${serviceId}/ftp?application=${application}`,
      providesTags: [TagTypesEnum.ConnectorFTP],
    }),
  }),
});
